import { buildQueryString } from '../helpers/Utils';

export default class Events {
  constructor(api) {
    this.api = api;
  }

  find(query) {
    const queryString = buildQueryString(query);
    return this.api.fetchJson('/api/events/find' + queryString, {});
  }
}
